module.exports = __webpack_public_path__ + "static/media/storieOne.ed146b4e.png";